var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlowDeliveryReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H76C78.2091 0 80 1.79086 80 4V76C80 78.2091 78.2091 80 76 80H4C1.79086 80 0 78.2091 0 76V4Z",
    fill: "#4EC669"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5486_3024",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 20,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5486_3024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7779 55C27.014 55 26.36 54.728 25.8158 54.1842C25.2719 53.64 25 52.986 25 52.2221V27.7779C25 27.014 25.2719 26.36 25.8158 25.8158C26.36 25.2719 27.014 25 27.7779 25H35.8054C36.0185 24.0186 36.5163 23.2176 37.2988 22.5971C38.081 21.9768 38.9814 21.6667 40 21.6667C41.0186 21.6667 41.919 21.9768 42.7013 22.5971C43.4838 23.2176 43.9815 24.0186 44.1946 25H52.2221C52.986 25 53.64 25.2719 54.1842 25.8158C54.7281 26.36 55 27.014 55 27.7779V52.2221C55 52.986 54.7281 53.64 54.1842 54.1842C53.64 54.728 52.986 55 52.2221 55H27.7779ZM27.7779 52.2221H52.2221V27.7779H27.7779V52.2221ZM31.6667 48.3333H43.1388V45.5554H31.6667V48.3333ZM31.6667 41.3887H48.3333V38.6112H31.6667V41.3887ZM31.6667 34.4446H48.3333V31.6667H31.6667V34.4446ZM40 26.8887C40.3797 26.8887 40.7061 26.7522 40.9792 26.4792C41.2522 26.2061 41.3888 25.8797 41.3888 25.5C41.3888 25.1203 41.2522 24.7939 40.9792 24.5208C40.7061 24.2478 40.3797 24.1112 40 24.1112C39.6203 24.1112 39.2939 24.2478 39.0208 24.5208C38.7478 24.7939 38.6113 25.1203 38.6113 25.5C38.6113 25.8797 38.7478 26.2061 39.0208 26.4792C39.2939 26.7522 39.6203 26.8887 40 26.8887Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlowDeliveryReports);
export default __webpack_public_path__ + "static/media/icon-flow-delivery-reports.c4647816263a5b03b6338de15e6f249f.svg";
export { ForwardRef as ReactComponent };